import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postSmsTemplateList: (params: SmsTemplateListReqDto): Promise<SmsTempalteListResDto> =>
    request({
      url: endpoints.smstemplate.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postSmsTemplateInfo: (params: SmsTemplateSaveReqDto): Promise<SmsTempalteInfoResDto> =>
    request({
      url: endpoints.smstemplate.info,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postSmsTemplateAdd: (params: SmsTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.smstemplate.add,
      method: 'post',
      data: paramsToFormData(params),
    }),
   postSmsTemplateSave: (params: SmsTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.smstemplate.update,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postSmsTemplateDelete: (params: SmsTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.smstemplate.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),        
};
